
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import store from '@/store/store';

import CardPopup from '@/../bower_components/teknisavuecomponents/components/dashboard/CardPopup.vue';

import Time from '@/../bower_components/teknisavuecomponents/assets/utils/Time';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import FormatacaoHora from '@/../bower_components/teknisavuecomponents/assets/utils/FormatacaoHora';

import { Periodo } from '../../bower_components/teknisavuecomponents/assets/interfaces/interfaces';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

import { SolicitacaoController } from '@/assets/ts/controller/SolicitacaoController';
import  IndicadoresController from '@/assets/ts/controller/IndicadoresController';
import OfflineController from '@/assets/ts/controller/OfflineController';
import DynamicRepository from '@/assets/ts/offline/repository/DynamicRepository';
import { CardData } from "@/assets/ts/interfaces/Dashboard";

@Component({
  name: 'InformationPanel',
  components: {
    CardPopup,
  },
})
export default class InformationPanel extends Vue {
  @Prop({ default: '' })
  private readonly estrutura: string;

  @Prop({ default: '' })
  private readonly periodo: string;

  @Prop({ default: 0 })
  private readonly triggerReload: number;

  // STORE
  @Getter('user')
  private user: any;

  @Getter('isOffline')
  private isOffline: any;

  showPopup = !OfflineController.checkIsOffline();
  loadingCards = false;

  // DATA
  // Deve ter o mesmo nome do this.card.name
  private cardsRows = {
    bancoDeHorasCard: [],
    atrasosCard: [],
    faltasInjCard: [],
    horasExtrasCard: [],
    atestadosCard: [],
    feriasCard: [],
    contratosCard: [],
    licencasCard: [],
    afastamentosCard: [],
    ultimasFeriasCard: [],
    ausenciaRegistroCard: [],
    solicitacoesPendentesCard: [],
    adcNoturnoCard: [],
    indicadoresAcidentesCard: [],
    indicadoresEpisCard: [],
    indicadoresReuniaoCard: [],
    indicadoresAfastamentosCidCard: [],
    indicadoresVariacaoSalarialCard: [],
  };

  private internTriggerReload = 0;

  private cardsLoading = [];

  private rowsTabAfastados = [];

  private rowsTabAfastadosTotalizador = [];

  private get cards(): CardData[] {
    const cards = [
      {
        name: 'bancoDeHorasCard',
        offlineTable: 'GPE_BANCOHORAS',
        title: 'Banco de Horas',
        icon: 'mdi-clock-outline',
        color: '#3A9FBC',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Banco de Horas',
            value: 'SALDO_FOLGAR_ACR_PER_BHR_NORM',
          },
        ],
        description: this.getBancoDescription,
        route: 'getMonitoramentoEquipeBancoHoras',
        items: this.cardsRows.bancoDeHorasCard,
        afterReload: this.afterReloadBancoDeHorasCard,
        finishedLoading: false,
      },
      {
        name: 'atrasosCard',
        offlineTable: 'GPE_ATRASOS',
        title: 'Atrasos',
        icon: 'mdi-account-clock-outline',
        color: '#4277C2',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Atraso',
            value: 'ATRASOS_DIURNOS',
          },
        ],
        description: this.getAtrasosDescription,
        route: 'getMonitoramentoEquipeAtrasos',
        items: this.cardsRows.atrasosCard,
        afterReload: this.afterReloadAtrasosCard,
        finishedLoading: false,
      },
      {
        name: 'faltasInjCard',
        offlineTable: 'GPE_FALTAS',
        title: 'Faltas Injustificadas',
        icon: 'mdi-account-off-outline',
        color: '#4251C2',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Faltas',
            value: 'QTD_FALTAS',
          },
        ],
        description: this.getFaltasInjDescription,
        route: 'getMonitoramentoEquipeFaltas',
        items: this.cardsRows.faltasInjCard,
        finishedLoading: false,
      },
      {
        name: 'horasExtrasCard',
        offlineTable: 'GPE_HORASEXTRAS',
        title: 'Horas Extras',
        icon: 'alarm_add',
        color: '#4293C2',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Horas Extras',
            value: 'EX_DIA_NORMAL_SEG',
          },
        ],
        description: this.getHorasExtrasDescription,
        route: 'getMonitoramentoEquipeHorasExtras',
        items: this.cardsRows.horasExtrasCard,
        afterReload: this.afterReloadHorasExtrasCard,
        finishedLoading: false,
      },
      {
        name: 'atestadosCard',
        offlineTable: 'GPE_ATESTADOS',
        title: 'Atestados',
        icon: 'mdi-text-box-outline',
        color: '#42C2B1',
        contentColor: 'white',
        showPopup: this.showPopup,
        description: this.getAtestadosDescription,
        items: this.cardsRows.atestadosCard,
        finishedLoading: false,
        renderTabs: true,
        tabsContent: [
          { 
            order: 0,
            mode: "view",
            description: 'Analítico',
            icon: 'mdi-add',
            headers: [
              {
                text: 'Nome',
                value: 'NMVINCULOM',
                type: 'text',
              },
              {
                text: 'Estrutura Legal',
                value: 'NMESTRUTLEGAL',
              },
              {
                text: 'Atestados',
                value: 'TOTAL_ATESTADOS',
                type: 'text',
              },
            ],
            route: 'getMonitoramentoEquipeAtestados',
            afterReload: this.tabAfastadosAfterReload,
            tableReadonly: true,
            reloadOnCreation: true,
          },
          {
            order: 1,
            mode: "view",
            description: 'Total por Unidade',
            icon: 'mdi-add',
            headers: [
              {
                text: 'Nome Estrutura',
                value: 'NMESTRUTLEGAL',
                type: 'text',
              },
              {
                text: 'Total',
                value: 'TOTALATESTADOS',
                type: 'text',
              },
            ],
            tableReadonly: true,
            reloadOnCreation: true,
            rows: this.rowsTabAfastados,
          }
        ],
      },
      {
        name: 'feriasCard',
        offlineTable: 'GPE_FERIAS',
        title: 'Férias a Vencer',
        icon: 'mdi-island',
        color: '#5142C2',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Vencimento',
            value: 'DTFIMAQUISICAO',
          },
          {
            text: 'Dias de Gozo',
            value: 'DIAS_GOZO',
          },
          {
            text: 'Data Limite',
            value: 'DATA_LIMITE',
          },
          {
            text: 'Status',
            value: 'IDCONTROLFERIAS',
          },
        ],
        description: this.getFeriasDescription,
        route: 'getMonitoramentoEquipeFerias',
        items: this.cardsRows.feriasCard,
        finishedLoading: false,
      },
      {
        name: 'contratosCard',
        offlineTable: 'GPE_CONTRATOS',
        title: 'Contratos a Vencer',
        icon: 'mdi-clipboard-alert-outline',
        color: '#545899',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
          text: 'Nr Vínculo',
          value: 'NRVINCULOM',
          },
          {
          text: 'Nome',
          value: 'NMVINCULOM',
          },
          {
          text: 'Tipo de Vínculo',
          value: 'NMTIPOVINCULOH',
          },
          {
            text: 'Data de Admissão',
            value: 'DTADMISSAOVINC',
          },
          {
            text: 'Vencimento 1ª Exp.',
            value: 'PRIMEIRA_PRORROGACAO',
          },
          {
            text: 'Vencimento 2ª Exp.',
            value: 'SEGUNDA_PRORROGACAO',
          },
          {
            text: 'Dias p/ Vencer',
            value: 'DIAS_CONTRATO_VENCER',
          },
          {
            text: 'Prorrogação',
            value: 'SEGUNDA_PRORROGACAO',
          },
        ],
        description: this.getContratosDescription,
        route: 'getMonitoramentoEquipeContrato',
        items: this.cardsRows.contratosCard,
        finishedLoading: false,
      },
      {
        name: 'licencasCard',
        offlineTable: 'GPE_LICMATERNIDADE',
        title: 'Lic. Maternidade a Vencer',
        popupTitle: 'Licenças Maternidade a Vencer',
        icon: 'mdi-baby-carriage',
        color: '#0483d1',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Estrutura',
            value: 'NMESTRUTURAH',
          },
          {
            text: 'Vencimento',
            value: 'DATA_FINAL',
          },
        ],
        description: this.getContratosDescription,
        route: 'getMonitoramentoEquipeLicenca',
        items: this.cardsRows.licencasCard,
        finishedLoading: false,
      },
      {
        name: 'afastamentosCard',
        offlineTable: 'GPE_AFASTAMENTOS',
        title: 'Afastamentos',
        popupTitle: 'Afastamentos',
        icon: 'mdi-account-multiple-remove',
        color: '#4DD0E1',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Situação Funcional',
            value: 'NMSITUFUNCH',
          },
          {
            text: 'Início',
            value: 'DATA_INICIO',
          },
          {
            text: 'Término',
            value: 'DATA_TERMINO',
          },
          {
            text: 'Dias de Afastamento',
            value: 'DIAS_AFASTAMENTO',
          },
        ],
        description: this.getContratosDescription,
        route: 'getMonitoramentoEquipeAfastamentos',
        items: this.cardsRows.afastamentosCard,
        finishedLoading: false,
      },
      {
        name: 'ultimasFeriasCard',
        offlineTable: 'GPE_ULTIMASFERIAS',
        title: 'Últimas Férias',
        popupTitle: 'Últimas Férias',
        icon: 'mdi-beach',
        color: '#547A99',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nr. Vínculo',
            value: 'NRVINCULOM',
          },
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Data Início',
            value: 'DTINIGOZOFERIAS',
          },
          {
            text: 'Data Fim',
            value: 'DTFIMGOZOFERIAS',
          },
          {
            text: 'Dias em Férias',
            value: 'TOTAL_GOZO',
          },
          {
            text: 'Dias Restantes',
            value: 'DIAS_RESTANTE_GOZO',
          },
          {
            text: 'Status',
            value: 'IDCONTROLFERIAS',
          },
        ],
        description: this.getUltimasFeriasCardDescription,
        route: 'getMonitoramentoEquipeUltimasFerias',
        items: this.cardsRows.ultimasFeriasCard,
        finishedLoading: false,
        rowStyle: (item: any) => { return item.VINC_EM_GOZO == 'S' ? 'color: blue' : '' },
      },
      {
        name: 'ausenciaRegistroCard',
        offlineTable: 'GPE_AUSENCIAREGISTRO',
        title: 'Ausência de Registros',
        popupTitle: 'Ausência de Registros',
        icon: 'timer_off',
        color: '#191970',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Nr. Vínculo',
            value: 'NRVINCULOM',
          },
          {
            text: 'Ultima Marcação',
            value: 'ULTIMA_MARCACAO',
          },
          {
            text: 'Estrutura Gerencial',
            value: 'NMESTRUTGEREN',
          },
        ],
        description: this.getContratosDescription,
        route: 'getMonitoramentoAusenciaMarcacaoPrevista',
        items: this.cardsRows.ausenciaRegistroCard,
        finishedLoading: false,
      },
      {
        name: 'solicitacoesPendentesCard',
        offlineTable: 'GPE_SOLICITACAO',
        title: 'Solicitações Pendentes',
        popupTitle: 'Solicitações Pendentes',
        icon: 'swap_vert',
        color: '#4A55A2',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
          text: 'Nr. Vínculo',
          value: 'NRVINCULOM',
          },
          {
            text: 'Vínculo',
            value: 'NMVINCULOM',
          },
          {
            text: 'Nr. Solicitação',
            value: 'NRSOLICITACAO',
          },
          {
            text: 'Data da Solicitação',
            value: 'DTSOLICITACAO',
          },
          {
            text: 'Tipo de Solicitação',
            value: 'NMTIPOSOLICITACAO',
          },
          {
            text: 'Observação',
            value: 'DSOBSSOLICITACAOABREV',
          },
          {
            text: 'Aprovação',
            value: 'DSAPROVACAOSEC',
          },
        ],
        route: 'getSolicitacoesVinculosGestor',
        items: this.cardsRows.solicitacoesPendentesCard,
        afterReload: this.afterReloadSolicitacaoCard,
        description: this.getSolicitacoesPendentesDescription,
        finishedLoading: false,
      },
      {
        name: 'adcNoturnoCard',
        offlineTable: 'GPE_ADCNOTURNO',
        title: 'Adicional Noturno',
        icon: 'snooze',
        color: '#4293C2',
        contentColor: 'white',
        showPopup: this.showPopup,
        headers: [
          {
            text: 'Nome',
            value: 'NMVINCULOM',
          },
          {
            text: 'Adicional Noturno',
            value: 'HRADICIONALNOTURNO',
          },
        ],
        description: this.getAdcNoturnoDescription,
        route: 'getMonitoramentoEquipeAdcNoturno',
        items: this.cardsRows.adcNoturnoCard,
        afterReload: this.afterReloadAdcNoturno,
        finishedLoading: false,
      },
      {
        name: 'indicadoresAcidentesCard',
        offlineTable: 'GPE_INDICAACIDENTE',
        title: 'Acidentes',
        icon: 'mdi-hospital-box',
        color: '#8598D8',
        contentColor: 'white',
        showPopup: false,
        finishedLoading: false,
        route: 'getTotalAcidentes',
        items: this.cardsRows.indicadoresAcidentesCard,
        description: this.getTotalAcidentesDescription,
        onClick: this.indicadoresAcidentesCardOnClick,
      },
      {
        name: 'indicadoresEpisCard',
        offlineTable: 'GPE_INDICAEPI',
        title: 'EPIs Entregues',
        icon: 'mdi-hard-hat',
        color: '#37B09C',
        contentColor: 'white',
        showPopup: false,
        finishedLoading: false,
        route: 'getTotalEpisEntreguesLegalOcup',
        items: this.cardsRows.indicadoresEpisCard,
        description: this.getTotalEpisEntreguesDescription,
        onClick: this.indicadoresEpisEntreguesCardOnClick,
      },
      {
        name: 'indicadoresReuniaoCard',
        offlineTable: 'GPE_INDICAREUNIAO',
        title: 'Reuniões no Ano',
        icon: 'mdi-account-group',
        color: '#3E4BB8',
        contentColor: 'white',
        showPopup: false,
        finishedLoading: false,
        route: 'getReuniaoPorAno',
        items: this.cardsRows.indicadoresReuniaoCard,
        description: this.getTotalReunioesDescription,
        onClick: this.indicadoresReunioesCardOnClick,
      },
       {
        name: 'indicadoresAfastamentosCidCard',
        offlineTable: 'GPE_INDICAAFASTAMENTO',
        title: 'Afastamentos por CID',
        icon: 'mdi-account-group',
        color: '#00BCD4',
        contentColor: 'white',
        showPopup: false,
        finishedLoading: false,
        route: 'getTotalAfastamentosPorCIDLegalOcupacao',
        items: this.cardsRows.indicadoresAfastamentosCidCard,
        description: this.getTotalAfastamentosCIDDescription,
        onClick: this.indicadoresAfastamentosCIDCardOnClick,
      },
      {
        name: 'indicadoresVariacaoSalarialCard',
        offlineTable: '',
        title: 'Médias Salariais',
        icon: 'mdi-chart-line',
        color: '#5E72E4',
        contentColor: 'white',
        showPopup: false,
        finishedLoading: false,
        route: 'getTotalVariacaoSalarialPorCBOGeral',
        items: this.cardsRows.indicadoresVariacaoSalarialCard,
        description: this.getTotalAVariacaoSalarialDescription,
        onClick: this.indicadoresVariacaoSalarialOnClick,
      },
    ];
    
    return cards;
  }

  private defaultDescription = '';

  // LIFECYCLE
  private mounted() {
    const userRestrition = this.user.idpgrestringetelaregist;
    
    if(userRestrition) {
      this.showPopup = false;
      return;
    }
  }


  // WATCH
  @Watch('triggerReload')
  private triggerReloadOnChange() {
    this.reload();
  }

  @Watch('isOffline')
  private offlineOnChange() {
    const userRestrition = this.user.idpgrestringetelaregist;

    if(userRestrition) {
      this.showPopup = false;
      return;
    }
    
    this.showPopup = !this.isOffline; 
    this.$forceUpdate();
  }

  // COMPUTED
  private get requestParams() : any {
    const user = this.user;

    const cdOperador = user.cdoperador;
    const nrOrg = user.nrorg;
    const nrTipoVinculo = user.nrtipovinculom;

    const params = {
      requestType: 'FilterData',
      CDOPERADOR: cdOperador,
      CDOPERADOR_APROVANTE: cdOperador,
      NRORG: nrOrg,
      NRTIPOVINCULOM: nrTipoVinculo,
      NRPERIODOAPURACAO: this.periodo,
      NRESTRUTURAM: this.estrutura,
    };

    return params;
  }

  private get isLoading() : boolean {
    const loading = this.cardsLoading.length > 0;

    return loading;
  }

  private get filtersAreSelected(): boolean {
    const areSelected =
      !Util.isEmptyOrBlank(this.periodo) &&
      !Util.isEmptyOrBlank(this.estrutura);

      return areSelected;
  }

  // METHODS
  private cardAfterReload(card: any, functionParams) {
    const afterReloadProperty = card.afterReload;

    this.cardsRows[card.name] = functionParams;

    if (card.bkpDescription) {
      card.description = card.bkpDescription;
    }

    if (afterReloadProperty) {
      afterReloadProperty(functionParams);
    }

    this.cardAfterLoading(card);
  }

  private cardOnError(card: any) {
    const errorMessage = `Não foi possível carregar "${card.title}".`;
    const cardErrorMessage = '';
    SnackbarUtils.showMessage(errorMessage, 'error');

    // Faz um backup da descrição original do card
    if (card.description !== cardErrorMessage) {
      card.bkpDescription = card.description;
    }

    card.description = this.defaultDescription;
    this.cardsRows[card.name] = [];

    this.cardAfterLoading(card);
  }

  private cardAfterLoading(card: any) {
    this.cardsLoading = Util.arrayRemoveCondition(
      this.cardsLoading,
      (x: any) => x.name === card.name,
      true);

    if (!this.isLoading) {
      this.$emit('after-reload', this.cardsRows);
    }
  }

  private afterReloadBancoDeHorasCard(rows: any) {
    for (const row of rows) {
      row.SALDO_FOLGAR_ACR_PER_BHR_NORM = FormatacaoHora.formataHoraDecimal(row.SALDO_FOLGAR_ACR_PER_BHR_NORM);
      row.SALDO_FOLGAR_PER_BHR_NORM = FormatacaoHora.formataHoraDecimal(row.SALDO_FOLGAR_PER_BHR_NORM);
    }

    this.cardsRows.bancoDeHorasCard = rows;
  }

  private afterReloadAtrasosCard(rows: any) {
    for (const row of rows) {
      row.ATRASOS_DIURNOS = FormatacaoHora.formataHoraDecimal(row.ATRASOS_DIURNOS);
    }

    this.cardsRows.atrasosCard = rows;
  }

  private afterReloadHorasExtrasCard(rows: any) {
    for (const row of rows) {
      row.EX_DIA_NORMAL_NP_SEG = FormatacaoHora.formataHoraDecimal(row.EX_DIA_NORMAL_NP_SEG);
      row.EX_DIA_NORMAL_SEG = FormatacaoHora.formataHoraDecimal(row.EX_DIA_NORMAL_SEG);
    }

    this.cardsRows.horasExtrasCard = rows;
  }

  private afterReloadSolicitacaoCard(rows: any) {
    const solicitacoes = rows.filter((row: any) => ['P', 'E'].includes(row.IDAPROVACAOSEC));

    this.cardsRows.solicitacoesPendentesCard = solicitacoes;
  }

  private afterReloadAdcNoturno(rows: any) {
    for (const row of rows) {
      row.HRADICIONALNOTURNO = FormatacaoHora.formataHoraDecimal(row.HRADICIONALNOTURNO);
    }

    this.cardsRows.adcNoturnoCard = rows;
  }

  private getBancoDescription(items: any[]): string {
    const bancoStrArray = items.map((x: any) => x.SALDO_FOLGAR_ACR_PER_BHR_NORM);

    const bancoTimeArray = bancoStrArray.map((x: any) => Time.fromString(x));

    const bancoDescription = Time.sumArray(bancoTimeArray).toString('HH:MM');

    return bancoDescription;
  }

  private getHorasExtrasDescription(items: any[]): string {
    const horasExtrasStrArray = items.map((x: any) => x.EX_DIA_NORMAL_SEG);

    const horasExtrasTimeArray = horasExtrasStrArray.map((x: any) => Time.fromString(x));

    const horasExtrasDescription = Time.sumArray(horasExtrasTimeArray)
      .toString('HH:MM');

    return horasExtrasDescription;
  }

    private getAdcNoturnoDescription(items: any[]): string {
    const adcNoturnoStrArray = items.map((x: any) => x.HRADICIONALNOTURNO);

    const adcNoturnoTimeArray = adcNoturnoStrArray.map((x: any) => Time.fromString(x));

    const adcNoturnoDescription = Time.sumArray(adcNoturnoTimeArray)
      .toString('HH:MM');

    return adcNoturnoDescription;
  }

  private getAtrasosDescription(items: any[]): string {
    const atrasosStrArray = items.map((x: any) => x.ATRASOS_DIURNOS);

    const atrasosTimeArray = atrasosStrArray.map((x: any) => Time.fromString(x));

    const atrasosDescription = Time.sumArray(atrasosTimeArray)
      .toString('HH:MM');

    return atrasosDescription;
  }

  private getFaltasInjDescription(items: any[]): string {
    const faltasArray = items.map((x: any) => parseInt(x.QTD_FALTAS, 10));

    const faltasInjDescription  = faltasArray.reduce(
      (accumulator, faltas) => accumulator + faltas, 0);

    return faltasInjDescription.toString();
  }

  private getAtestadosDescription(items: any[], tabs: any[]): string {
    if(Util.isEmptyOrBlank(tabs) || !Array.isArray(tabs[0])) {
      return "0";
    }

    const atestadosArray = tabs[0].map((x: any) => parseInt(x.TOTAL_ATESTADOS, 10));

    const totalAtestados  = atestadosArray.reduce(
      (atestados : number, accumulator : number) => accumulator + atestados, 0);

    const atestadosDescription = totalAtestados.toString();

    return atestadosDescription;
  }

  private getUltimasFeriasCardDescription(items: any[]): string {
    const description = items.filter((item: any) => item.VINC_EM_GOZO == 'S').length.toString();

    return description;
  }

  private getFeriasDescription(items: any[]): string {
    const feriasDescription = items.length.toString();

    return feriasDescription;
  }

  private getContratosDescription(items: any[]): string {
    const contratosDescription = items.length.toString();

    return contratosDescription;
  }

  private getLicencaDescription(items: any[]): string {
    const licencaDescription = items.length.toString();

    return licencaDescription;
  }

  private getSolicitacoesPendentesDescription(items: any[]): string {
    const solicitacoesDescription = items.length.toString();

    return solicitacoesDescription;
  }

  private getTotalAcidentesDescription(item: any): string {
    if (item && item[0] && item[0].QTD_ACIDENTES !== undefined) {
      return item[0].QTD_ACIDENTES;
    } else {
      return "0";
    }
  }

    private getTotalEpisEntreguesDescription(item: any): string {
    if (item && item[0] && item[0].QTD_EPIS !== undefined) {
      return item[0].QTD_EPIS;
    } else {
      return "0";
    }
  }

  private getTotalReunioesDescription(item: any): string {
    if (item && item[0] && item[0].TOTAL !== undefined) {
      return item[0].TOTAL;
    } else {
      return "0";
    }
  }


  private getTotalAfastamentosCIDDescription(item: any): string {
    if (item && item[0] && item[0].QTD_AFASTAMENTOS !== undefined) {
      return item[0].QTD_AFASTAMENTOS;
    } else {
      return "0";
    }
  }

  private getTotalAVariacaoSalarialDescription(item: any): string {
    if (item && item[0] && item[0].MEDIA_GERAL_ORGANIZACAO !== undefined) {
      return item[0].MEDIA_GERAL_ORGANIZACAO;
    } else {
      return "0";
    }
  }

  private getCardByName(cardName: string) {
    const card = this.cards.find((x: any) => x.name === cardName);

    return card;
  }

  private reload() {
    const cardsWithRoute = this.cards.filter(card => card.route);

    if(this.loadingCards) return;

    if (this.filtersAreSelected) {
      this.cardsLoading = cardsWithRoute;
      this.internTriggerReload++;
      this.getDataForCards();
    }
  }

  private getCardDescription(card: any) {
    const description = this.filtersAreSelected ?
      card.description :
      this.defaultDescription;

    return description;
  }
  
  private indicadoresAcidentesCardOnClick() {
    IndicadoresController.redirectToIndicadoresFiltered();
  }

  private indicadoresEpisEntreguesCardOnClick() {
    IndicadoresController.redirectToTotalEpisEntreguesFiltered();
  }

  private indicadoresReunioesCardOnClick() {
    IndicadoresController.redirectToTotalReunioesFiltered();
  }

  private indicadoresAfastamentosCIDCardOnClick() {
     IndicadoresController.redirectToTotalAfastamentosCIDFiltered();
  }

  private indicadoresVariacaoSalarialOnClick() {
     IndicadoresController.redirectToVariacaoSalarialFiltered();
  }

  private tabAfastadosAfterReload(rows) {

    const unique = [...new Set(rows.map(i => i.NMESTRUTLEGAL))].map((i) => { return {NMESTRUTLEGAL: i, TOTALATESTADOS: 0} });

    rows.reduce((acc, obj) => {
            let curCount = acc.find(a => a.NMESTRUTLEGAL == obj.NMESTRUTLEGAL);
            if (curCount) {
              curCount.TOTALATESTADOS = parseInt(curCount.TOTALATESTADOS) + parseInt(obj.TOTAL_ATESTADOS);
            }
            return acc;
        },
    unique);

    this.rowsTabAfastados = unique; 
  }

  /**
   * Obtém dados para os cards do dashboard, lidando com cenários online e offline.
   * 
   * Esta função itera sobre o array `cards` e realiza as requisições necessárias
   * para obter os dados de cada card. Se a aplicação estiver offline, carrega os
   * dados do SQLite; caso contrário, faz uma requisição HTTP para obter
   * os dados. Após obter os dados, emite um evento 'after-reload' para indicar que o carregamento
   * do dashboard foi concluído.
  */
  private async getDataForCards() {
    const isOffline = OfflineController.checkIsOffline();
  
    this.loadingCards = true;
    try {
      const promises = this.cards.map(async (card) => {
      if (card.route) {
        if (isOffline) {
          await this.loadOfflineData(card);
        } else {
          await this.loadOnlineData(card);
        }
      }
    });

    await Promise.all(promises); 
    } finally {
      this.loadingCards = false;
    }

    this.$emit('after-reload', this.cardsRows);
  }

  /**
   * Carrega dados de cada card (para não depender do component CardPopup chamar as Requests)
   * 
   * Caso a prop :is-not-router do CardPoup esteja como true, o component não irá chamar a request, tornando essa função necessária.
  */
  private async loadOnlineData(card: CardData) {
    try {
      card.loading = true;
      const resp = await HttpRequest.get(card.route, this.requestParams, false);
      const rows = resp.data.dataset.data || resp.data.dataset[card.route];

      this.cardsRows[card.name] = Util.deepCopy(rows);
      this.cardAfterReload(card, rows);

      if(OfflineController.isMobile()) {
        await this.saveOfflineData(card, rows);
      }
    } catch (error) {
      console.log(`Ocorreu um erro ao pegar os dados do Card - ${card.title}: ${error}`);
      //SnackbarUtils.showMessage(`Ocorreu um erro ao pegar os dados do Card - ${card.title}:<br>\n ${error}`, SnackbarUtils.TYPE_ERROR);
    } finally {
      card.loading = false;
    }
  };


  /**
   * Carrega dados do armazenamento offline (SQLite) para um card específico.
   * 
  */
  private async loadOfflineData(card: CardData) {
    try {
      if(!card.offlineTable) return;

      const rows = await DynamicRepository.getDynamicTable(card.offlineTable);
      this.cardsRows[card.name] = rows;
      this.cardAfterReload(card, rows);
    } catch (error) {
      console.log(`Ocorreu um erro ao pegar os dados Offline do Card - ${card.title}: ${error}`);
      SnackbarUtils.showMessage(`Ocorreu um erro ao pegar os dados Offline do Card - ${card.title}:<br>\n ${error}`, SnackbarUtils.TYPE_ERROR);
    }
  }

  /**
   * Salva dados no armazenamento offline para um card específico.
   * 
   * Usando a Classe Dinâmica DynamicRepository os dados de cada card são salvos dinamicamente baseados no arquivo DynamicTables.ts
  */
  private async saveOfflineData(card: CardData, rows: any[]) {
    try {
      if(!card.offlineTable) return;

      await DynamicRepository.deleteDynamicTable(card.offlineTable);
      await DynamicRepository.setDynamicTableValues(card.offlineTable, rows);
      const row = await DynamicRepository.getDynamicTable(card.offlineTable);
    } catch (error) {
      console.log(`Ocorreu um erro ao salvar os dados do Card: ${card.title} para uso Offline: ${error}`);
      SnackbarUtils.showMessage(`Ocorreu um erro ao salvar os dados Card: ${card.title} para uso offline:<br>\n ${error}`, SnackbarUtils.TYPE_ERROR);
    }
  }
  
}
